import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["player"]

  connect() {
    this.playerTargets.forEach(el => {
      if (this._hasYouTubeUrl(el.dataset.videoUrl)) {
        el.addEventListener("click", this._open.bind(this))
      }
    })
  }

  _open(event) {
    const container = event.currentTarget
    const videoUrl = container.dataset.videoUrl
    if (!videoUrl) return
    window.open(videoUrl, "_blank", "noopener,noreferrer")
  }

  _hasYouTubeUrl(url) {
    return url && (url.includes("youtube.com") || url.includes("youtu.be"))
  }
}
